import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { SpjpCommunityService } from '@spjp/services/community.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FlowGuard {
    constructor(
        private router: Router,
        private communityService: SpjpCommunityService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.communityService.fetchCommunity(route.params).pipe(
            switchMap((community) => {
                switch (route.routeConfig.path) {
                    case 'register-b2b':
                        if (!community.isB2B) {
                            const commands = [community.code, 'register'];
                            if (route.firstChild?.params?.id) {
                                commands.push(route.firstChild?.params?.id);
                            }
                            return of(
                                this.router.createUrlTree(commands, {
                                    preserveFragment: true,
                                    queryParamsHandling: 'merge',
                                    queryParams: route.queryParams,
                                }),
                            );
                        }
                        break;
                    case 'register':
                    default:
                        if (community.isB2B) {
                            const commands = [community.code, 'register-b2b'];
                            if (route.firstChild?.params?.id) {
                                commands.push(route.firstChild?.params?.id);
                            }
                            return of(
                                this.router.createUrlTree(commands, {
                                    preserveFragment: true,
                                    queryParamsHandling: 'merge',
                                    queryParams: route.queryParams,
                                }),
                            );
                        }
                        break;
                }
                return of(true);
            }),
        );
    }
}
